import { render, staticRenderFns } from "./NewToOnWarehouseOrder.vue?vue&type=template&id=9fa45aec&scoped=true&"
import script from "./NewToOnWarehouseOrder.vue?vue&type=script&lang=js&"
export * from "./NewToOnWarehouseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa45aec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fa45aec')) {
      api.createRecord('9fa45aec', component.options)
    } else {
      api.reload('9fa45aec', component.options)
    }
    module.hot.accept("./NewToOnWarehouseOrder.vue?vue&type=template&id=9fa45aec&scoped=true&", function () {
      api.rerender('9fa45aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Orders/View/NewToOnWarehouseOrder.vue"
export default component.exports